/// <reference path="../../app.d.ts"/>
/// <reference path="../../../../typings/jquery.d.ts"/>
import { AppUtils } from '../../../../../shared/utils/index';
import { FeedbackFormModel, FeedbackType } from '../models/FeedbackFormModel';
import { BasicViewService } from "../../../../../shared/services/BasicViewService";
import { PriceCorrectionModel } from '../models/PriceCorrectionModel';
import { AdresseModel } from '../../../../../shared/models/view/Adresse';
import { GasStationCorrectionModel } from '../models/GasStationCorrectionModel';
import { BusinessHoursModel } from '../models/BusinessHoursModel';
import { CoordinatesModel } from '../../../../../shared/models/view/Coordinates';

export class AppViewService extends BasicViewService<FuelPricesUserFeedbackAppDefinition> {

	constructor(parent: StepController, options: BasicAppOptions<FuelPricesUserFeedbackAppDefinition>, loader: BasicLoader<FuelPricesUserFeedbackAppDefinition>) {
		super(parent, options, loader);
		this.formId = this.options.app.applicationId || 'fuelpricesuserfeedback';
	}

	/**
	 * adds listeners to form
	 */
	public addListeners(handler: StandardViewEvents): void {
		const $form = this.getForm();
		// init form listener
		$form.find('input, select, textarea').on('change', handler.viewChangeListener.bind(handler));
		$form.on('submit', handler.submitListener.bind(handler));

		this.$ctx.find('.js-submit-form').on('click', handler.submitListener.bind(handler));

		// init all form elements from ew72
		S.Utils.FormAside.init();
		AppUtils.View.initFormElements();
	}

	public getFormModelFromView(type: FeedbackType, formModel?: FeedbackFormModel): FeedbackFormModel {
		const result = formModel || new FeedbackFormModel(), formData = this.getFormData();
		if (FeedbackType.PRICE === type) {
			result.PriceCorrection = new PriceCorrectionModel({
				PreisSuperE10: this.parseDecimalInput(formData.PreisSuperE10),
				PreisSuper: this.parseDecimalInput(formData.PreisSuper),
				PreisDiesel: this.parseDecimalInput(formData.PreisDiesel)
			});
		} else if (FeedbackType.GASSTATION === type) {
			const correction = new GasStationCorrectionModel({
				Name: formData.TankstelleName,
				Marke: formData.TankstelleBetreiber
			});
			if (formData.TankstelleStrasseHausnummer || formData.TankstellePostleitzahl || formData.TankstelleOrt) {
				correction.Adresse = new AdresseModel();
				correction.Adresse.StrasseHausnummer = formData.TankstelleStrasseHausnummer;
				correction.Adresse.Postleitzahl = formData.TankstellePostleitzahl;
				correction.Adresse.Ort = formData.TankstelleOrt;
			}
			if (formData.TankstelleGeoeffnetAm || formData.TankstelleGeoeffnetVon || formData.TankstelleGeoeffnetBis) {
				correction.OeffnungsZeiten = new BusinessHoursModel({
					Wochentag: formData.TankstelleGeoeffnetAm,
					Von: formData.TankstelleGeoeffnetVon,
					Bis: formData.TankstelleGeoeffnetBis
				});
			}
			if (formData.TankstelleLatitude || formData.TankstelleLongitude) {
				correction.GeoPosition = new CoordinatesModel({
					Latitude: formData.TankstelleLatitude ? Number(formData.TankstelleLatitude.replace(",", ".")) : undefined,
					Longitude: formData.TankstelleLongitude ? Number(formData.TankstelleLongitude.replace(",", ".")) : undefined
				});
			}
			result.GasStationCorrection = correction;
		}
		result.EntdecktAm = formData.EntdecktAm;
		result.EntdecktUm = formData.EntdecktUm;
		return result;
	}

	public setFormModelToView(): void {
		// nothing yet;
	}

	public getVerificationToken(): string {
		return $('input[name="__RequestVerificationToken"]').val() as string;
	}

	public showGeneralError(message: string): void {
		const $elment = this.$ctx.find(".js-general");
		if (message) {
			$elment.html(message);
		}
		AppUtils.View.hideElement($elment, false);
		AppUtils.View.scrollTo(0);
	}

	public hideMessages(): void {
		AppUtils.View.hideElement(this.$ctx.find(".js-general"));
	}

	private parseDecimalInput(val: string): number {
		if (!val) {
			return undefined;
		}
		return Number(val.replace(",", "."));
	}
}
